'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Highlighter = require('./Highlighter');

var _Highlighter2 = _interopRequireDefault(_Highlighter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Highlighter2.default;